module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-24.57824bb7.svg";